import React from 'react';
import { Link } from 'react-router-dom';

class Home extends React.Component {

	render() {
		return (
			<div>
				<section className="hero">
					<div className="container">
						<div className="row">
							<div className="col-md-6 offset-md-3 text-center align-self-end">
								<h1 className="mt-4">My Mental Health Passport</h1>
								<img src="/assets/img/logo-white.svg" style={{width: 130, marginTop: `2em`}} alt="MyMHP"/>
								<p className="lead" style={{fontSize: 28, fontWeight: 300, letterSpacing: `0.02em`, marginTop: `4em`}}>A space for children and young people to store information about their mental health</p>
							</div>

						</div>
					</div>
				</section>

				<section className="block1">
					<div className="container" style={{paddingTop: 30, paddingBottom: 30}}>
						<div className="row">
							<div className="col-md-4" style={{paddingTop: 30, paddingRight: 60, paddingBottom: 60, paddingLeft: 60}}>
								<Link to="/advice"><img src="/assets/img/icon-signpost.svg" className="img-responsive" style={{maxHeight: 200, marginTop: `2em`}} alt="Mental Health Advice"/></Link>
							</div>
							<div className=" col-md-8 mt-4 mb-4">
								<h1 className="mt-5"><Link to="/advice">Find Help and Advice</Link></h1>
								<p className="mt-5" style={{fontSize: `1.4em`}}>
									A list of services if you need more information, support or urgent help.
								</p>
							</div>

						</div>
					</div>
				</section>

				<section className="block2">
					<div className="container" style={{paddingTop: 30, paddingBottom: 30}}>
						<div className="row">
							<div className=" col-md-8 mt-4 mb-4">
								<h1 className="mt-5"><Link to="/login">Create Your Mental Health Passport</Link></h1>
								<p className="mt-5" style={{fontSize: `1.4em`}}>
									This is owned by you. You don’t have to share any of this information with anyone else, but it could help when you’re talking to professionals and other people about your mental health.
								</p>
							</div>
							<div className="col-md-4" style={{paddingTop: 30, paddingRight: 60, paddingBottom: 60, paddingLeft: 60}}>
								<Link to="/login"><img src="/assets/img/icon-passport.svg" className="img-responsive" style={{maxHeight: 200, marginTop: `2em`}} alt="Passport"/></Link>
							</div>

						</div>
					</div>
				</section>

				<div className="mt-4 container">
					<div className="row" style={{marginBottom: 0}}>
						<div className="col-md-6 text-center text-md-left">
							<img src="/assets/img/chilypep-logo.svg" className="img-fluid" style={{height: 70, marginTop: `2em`}} alt="Chilypep"/>
						</div>
						<div className="col-md-3 text-center text-md-right">						
							<img src="/assets/img/sheffieldccg-logo.png" className="img-fluid" style={{maxHeight: 100, marginTop: `2em`}} alt="Sheffield CCG"/>
						</div>
						<div className="col-md-3 text-center text-md-right">						
							<img src="/assets/img/sheffield-council.png" className="img-fluid" style={{maxHeight: 100, marginTop: `2em`, marginLeft: `2em`}} alt="Sheffield CCG"/>
						</div>
					</div>
				</div>

			</div>
		);
	}
}




export default Home;



// WEBPACK FOOTER //
// ./src/js/components/Home/Home.js